import { isEmpty } from 'lodash'

import { App, Template } from '@/pages/SpaceAppBuilder/utilities/interfaces'

export default function isTemplateUpdateAvailable({ app, templates = [] }: { app?: App; templates?: Template[] }) {
  if (!app?.template || isEmpty(templates)) {
    return false
  }

  const currentTemplate = templates?.find((template: any) => template?.id === app.template?.templateId)

  const changeLog = currentTemplate?.metadata?.changelog

  if (!changeLog) return false

  return Number(app.template?.version) < Number(changeLog.at(0)!.version)
}
